import {Component, Input} from '@angular/core';
import {EDialogOpenMode} from '../../enums/dialog-open-mode.enum';
import {IBaseCRUModalComponent} from '../ibase-cru-modal/ibase-cru-modal.component';
import {PrimeNgImportsModule} from '../../prime-ng-imports';

/**
 * IBaseCRUModalComponent content base
 */
@Component({
    selector: 'app-ibase-cru-modal-content',
    templateUrl: './ibase-cru-modal-content.component.html',
    styles: [
        `
            :host {
                display: flex;
                flex-direction: column;
                height: 100%;
            }
        `
    ],
    imports: [PrimeNgImportsModule]
})
export class IBaseCRUModalContentComponent {
    protected readonly EDialogOpenMode = EDialogOpenMode;

    // ===============================================================
    // ===============================================================

    @Input()
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public iBaseCRUModal?: IBaseCRUModalComponent<any, any, any, any>;

    @Input()
    public showDefaultFormFooter = false;

    @Input()
    public showGoTo = false;

    @Input()
    public showPrevious = false;
    @Input()
    public previousEnabled = true;

    @Input()
    public showNext = false;
    @Input()
    public nextEnabled = true;

    @Input()
    public showCreate = true;
    @Input()
    public createButtonLabel = 'Create';
    @Input()
    public updateButtonLabel = 'Update';

    @Input()
    public contentClasses?: string | string[] | Set<string>;
}
